import React, { useEffect, useState } from 'react';
import { message, Card } from 'antd';

import RowsTable from './components/rowsTable';
import PieChart from './components/pieChart';
import { memberTrainingOverviewIndicator } from '@/services/chartData';
const UserOverviewData = () => {
  const [columnsData1, setColumnsData1] = useState([]);
  const [columnsData2, setColumnsData2] = useState([]);

  const [tableDataSource1, setTableDataSource1] = useState([]);
  const [tableDataSource2, setTableDataSource2] = useState([]);

  const [pieData1, setPieData1] = useState([]);
  const [pieData2, setPieData2] = useState([]);
  const queryMemberOverviewData = () => {
    memberTrainingOverviewIndicator({
      requestData: {},
    }).then(({ code, msg, data }) => {
      if (code === '00000') {
        setDatas(data);
      } else {
        message.error(msg);
      }
    });
  };
  const setDatas = (data) => {
    setColumnsData1(data.littaMemberTrainingOverview.columns);
    setColumnsData2(data.ptMemberTrainingOverview.columns);
    setTableDataSource1(data.littaMemberTrainingOverview.dataSource);
    setTableDataSource2(data.ptMemberTrainingOverview.dataSource);
    setPieData1(data.ptMemberLabelDistribution);
    setPieData2(data.littaMemberLabelDistribution);
  };
  useEffect(() => {
    queryMemberOverviewData();
  }, []);
  return (
    <div>
      {/* <div style={{ display: 'flex', marginBottom: '20px' }}> */}
      <Card
        title="LITTA私教会员训练数据"
        bordered={true}
        // style={{ width: '50%' }}
      >
        <RowsTable columnsData={columnsData2} dataSource={tableDataSource2} />
      </Card>
      <Card
        title="LITTA健身会员训练数据"
        bordered={true}
        // style={{ width: '50%' }}
      >
        <RowsTable columnsData={columnsData1} dataSource={tableDataSource1} />
      </Card>
      {/* </div> */}

      <div style={{ display: 'flex' }}>
        <Card
          title="LITTA私教会员类型分布"
          bordered={true}
          style={{ width: '50%' }}
        >
          <PieChart pieData={pieData1} colorField="label" />
        </Card>
        <Card
          title="LITTA健身会员类型分布"
          bordered={true}
          style={{ width: '50%' }}
        >
          <PieChart pieData={pieData2} colorField="label" />
        </Card>
      </div>
    </div>
  );
};

export default UserOverviewData;
